import { widgetImports } from './widgetRegistryConfig'

export const WidgetComponents = ({ widgetType, ...restProps }) => {
  const DynamicWidget = widgetImports[widgetType]

  if (!DynamicWidget) {
    return null
  }

  return (
    <DynamicWidget
      vehicleData={restProps.vehicleData}
      regNo={restProps.regNo}
      setWidgetModal={restProps.setWidgetModal}
      KeyFeatures={restProps.KeyFeatures}
      segmentEventCommonProperties={restProps.segmentEventCommonProperties}
      phone={restProps.phone}
      userData={restProps.userData}
      widgetType={widgetType}
      setRegNo={restProps.setRegNo}
      setVehicleData={restProps.setVehicleData}
    />
  )
}
